const PDF_ACTUACION_PARAM = "pdfActuacion";
const PDF_ATTACHMENT_PARAM = "pdfAdjunto";
const PDF_CUIJ_PARAM = "pdfCuij";

export const DOCUMENT_VIEWER_HISTORY_STATE = "praxisDocumentViewer";

function routeUrl(path, search) {
  return new URL(`${path}${search || ""}`, window.location.origin);
}

export function readDocumentViewerRoute(search, fallbackCuij = "") {
  const params = new URLSearchParams(search || "");
  return {
    actId: params.get(PDF_ACTUACION_PARAM) || "",
    attachmentId: params.get(PDF_ATTACHMENT_PARAM) || "",
    cuij: params.get(PDF_CUIJ_PARAM) || fallbackCuij,
  };
}

export function buildDocumentViewerRoute(
  path,
  search,
  { actId, attachmentId = "", cuij = "", includeCuij = false },
) {
  const target = routeUrl(path, search);
  target.searchParams.set(PDF_ACTUACION_PARAM, actId);
  if (attachmentId) target.searchParams.set(PDF_ATTACHMENT_PARAM, attachmentId);
  else target.searchParams.delete(PDF_ATTACHMENT_PARAM);
  if (includeCuij && cuij) target.searchParams.set(PDF_CUIJ_PARAM, cuij);
  else target.searchParams.delete(PDF_CUIJ_PARAM);
  return `${target.pathname}${target.search}${target.hash}`;
}

export function clearDocumentViewerRoute(path, search) {
  const target = routeUrl(path, search);
  target.searchParams.delete(PDF_ACTUACION_PARAM);
  target.searchParams.delete(PDF_ATTACHMENT_PARAM);
  target.searchParams.delete(PDF_CUIJ_PARAM);
  return `${target.pathname}${target.search}${target.hash}`;
}

export function closeDocumentViewerRoute({ path, search, navigate }) {
  if (window.history.state?.[DOCUMENT_VIEWER_HISTORY_STATE]) {
    window.history.back();
    return;
  }
  navigate(clearDocumentViewerRoute(path, search), { replace: true });
}
